import { useFetchClassesQuery } from "features/classes/classeSlice";
import { useFetchEnseignantsQuery } from "features/enseignants/enseignantSlice";
import { useFetchEtudiantsQuery } from "features/etudiants/etudiantSlice";
import { useFetchParentsQuery } from "features/parents/parentSlice";
import React from "react";
import { Card, Col, Placeholder } from "react-bootstrap";
import CountUp from "react-countup";

interface WidgetItem {
  name: string;
  amount: number;
  icon: string;
  iconColor: string;
  isLoading: boolean;
  isError: boolean;
}

const WidgetCard = ({ item }: { item: WidgetItem }) => (
  <Col xxl={3} lg={6} sm={6} xs={12}>
    <Card className="card-animate">
      <Card.Body>
        <div className="d-flex justify-content-between">
          <div
            className={`vr rounded bg-${item.iconColor} opacity-50`}
            style={{ width: "4px" }}
          />
          <div className="flex-grow-1 ms-3">
            <p className="text-uppercase fw-medium text-muted fs-14 text-truncate">
              {item.name}
            </p>
            {item.isLoading ? (
              <Placeholder as="h4" animation="glow" className="mb-3">
                <Placeholder xs={4} />
              </Placeholder>
            ) : item.isError ? (
              <h4 className="fs-22 fw-semibold mb-3 text-danger">
                <i className="ri-error-warning-line me-1" />
                Erreur
              </h4>
            ) : (
              <h4 className="fs-22 fw-semibold mb-3">
                <span className="counter-value">
                  <CountUp start={0} end={item.amount} separator="," />
                </span>
              </h4>
            )}
          </div>
          <div className="avatar-sm flex-shrink-0">
            <span
              className={`avatar-title bg-${item.iconColor}-subtle text-${item.iconColor} rounded fs-3`}
            >
              <i className={item.icon} />
            </span>
          </div>
        </div>
      </Card.Body>
    </Card>
  </Col>
);

const Widgets = () => {
  const {
    data: AllEtudiants = [],
    isLoading: loadingEtudiants,
    isError: errorEtudiants,
  } = useFetchEtudiantsQuery();
  const {
    data: AllClasses = [],
    isLoading: loadingClasses,
    isError: errorClasses,
  } = useFetchClassesQuery();
  const {
    data: AllEnseignants = [],
    isLoading: loadingEnseignants,
    isError: errorEnseignants,
  } = useFetchEnseignantsQuery();
  const {
    data: AllParents = [],
    isLoading: loadingParents,
    isError: errorParents,
  } = useFetchParentsQuery();

  const widgets: WidgetItem[] = [
    {
      name: "Élèves",
      amount: AllEtudiants.length,
      icon: "ph-student",
      iconColor: "secondary",
      isLoading: loadingEtudiants,
      isError: errorEtudiants,
    },
    {
      name: "Classes",
      amount: AllClasses.length,
      icon: "ph-graduation-cap",
      iconColor: "info",
      isLoading: loadingClasses,
      isError: errorClasses,
    },
    {
      name: "Enseignants",
      amount: AllEnseignants.length,
      icon: "ph-user-circle",
      iconColor: "warning",
      isLoading: loadingEnseignants,
      isError: errorEnseignants,
    },
    {
      name: "Parents",
      amount: AllParents.length,
      icon: "ph-users-three",
      iconColor: "success",
      isLoading: loadingParents,
      isError: errorParents,
    },
  ];

  return (
    <React.Fragment>
      {widgets.map((item, key) => (
        <WidgetCard key={key} item={item} />
      ))}
    </React.Fragment>
  );
};

export default Widgets;
